import {
  AcknowledgeAlarmIcon,
  AdjustmentCertificateIcon,
  FileSignatureIcon,
  ChannelIcon,
  GroupIcon,
  ConfigurationIcon,
  KeyIcon,
  UsersIcon,
  AcqChainIcon,
  ThermometerIcon,
  TransmitterIcon,
  DataloggingIcon,
  DutiesIcon,
  DatabaseIcon,
  CalendarAltIcon,
  UserIcon,
  VersionIcon,
  ServerIcon,
  CRCIcon,
  SystemSettingsIcon,
} from 'src/components/common/icons'
import { ClockIcon } from 'labguard-cdk'

export const categories = {
  ACK_COMMENT: { icon: AcknowledgeAlarmIcon, i18n: 'WEB_AUDIT_LOG_CATEGORY_ACK_COMMENT' },
  ADJUSTAGE: { icon: AdjustmentCertificateIcon, i18n: 'WEB_AUDIT_LOG_CATEGORY_ADJUSTAGE' },
  ALERT_MANAGER_STATION: { icon: ServerIcon, i18n: 'WEB_AUDIT_LOG_CATEGORY_ALERT_MANAGER_STATION' },
  CALIBRATION: { icon: FileSignatureIcon, i18n: 'WEB_AUDIT_LOG_CATEGORY_CALIBRATION' },
  CHANNEL: { icon: ChannelIcon, i18n: 'WEB_AUDIT_LOG_CATEGORY_CHANNEL' },
  CRC: { icon: CRCIcon, i18n: 'WEB_AUDIT_LOG_CATEGORY_CRC' },
  GROUPS: { icon: GroupIcon, i18n: 'WEB_AUDIT_LOG_CATEGORY_GROUPS' },
  DATABASE: { icon: DatabaseIcon, i18n: 'WEB_AUDIT_LOG_CATEGORY_DATABASE' },
  DATETIME: { icon: ClockIcon, i18n: 'WEB_AUDIT_LOG_CATEGORY_DATETIME' },
  DUTY: { icon: DutiesIcon, i18n: 'WEB_AUDIT_LOG_CATEGORY_DUTY' },
  DUTY_PARAMETER: { icon: DutiesIcon, i18n: 'WEB_AUDIT_LOG_CATEGORY_DUTY_PARAMETER' },
  EVISENSE_INSTALLED_VERSION: { icon: VersionIcon, i18n: 'WEB_AUDIT_LOG_CATEGORY_EVISENSE_INSTALLED_VERSION' },
  CONFIGURATION: { icon: ConfigurationIcon, i18n: 'WEB_AUDIT_LOG_CATEGORY_CONFIGURATION' },
  PLANNING: { icon: CalendarAltIcon, i18n: 'WEB_AUDIT_LOG_CATEGORY_PLANNING' },
  SECURITY: { icon: KeyIcon, i18n: 'WEB_AUDIT_LOG_CATEGORY_SECURITY' },
  TEAM: { icon: UsersIcon, i18n: 'WEB_AUDIT_LOG_CATEGORY_TEAM' },
  USER: { icon: UserIcon, i18n: 'WEB_AUDIT_LOG_CATEGORY_USER' },
  ACQ_CHAIN: { icon: AcqChainIcon, i18n: 'WEB_ACQ_CHAIN' },
  PROBE_CONFIGURATION: { icon: ThermometerIcon, i18n: 'WEB_PROBE_CONFIGURATION' },
  TRANSMITTER_CONFIGURATION: { icon: TransmitterIcon, i18n: 'WEB_TRANSMITTER_CONFIGURATION' },
  RECEIVER_CONFIGURATION: { icon: DataloggingIcon, i18n: 'WEB_RECEIVER_CONFIGURATION' },
  SYSTEM: { icon: SystemSettingsIcon, i18n: 'WEB_SYSTEM_SETTINGS' },
}
